// extracted by mini-css-extract-plugin
module.exports = {"ProductCards":"ProductCards_ProductCards__308Cy"};